module.exports = __webpack_public_path__ + "static/media/not-answered.70f4f6e3.svg";